import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../../routes/routes';

/**
 * The Stock Move desk is retired [SSD-7527]. Stock moves between shelves from the Inventory row's ✎ box: the whole
 * shelf by default, or "Move some units only" for a count, with the phone camera on the shelf box. The old address
 * lands on Inventory so a bookmark still goes somewhere.
 */
export default function FulfillmentStockMovePage() {
  return <Navigate to={ROUTES.fulfillment.inventory} replace />;
}
